import { getSafeAreaPaddings } from "@clipboard-health/ui-theme";
import { Stack, ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/lib/Theme/theme";
import { ShiftBlockPage } from "@src/appV2/redesign/ShiftDiscovery/Blocks/Page";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

export function ShiftBlocksPage() {
  const worker = useDefinedWorker();

  return (
    <ThemeProvider theme={getTheme("light")}>
      <Stack
        sx={{
          ...getSafeAreaPaddings({ top: true }),
          flex: 1,
          minHeight: 0,
        }}
      >
        <ShiftBlockPage agent={worker} />
      </Stack>
    </ThemeProvider>
  );
}
